<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" />
      <form-content
        id="form"
        :is-white="isWhiteButton"
        :subtitle="subtitle"
        :data="data"
      />
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import FormContent from "@/components/main/form/modules/FormContent.vue";

export default {
  name: "df-form",
  components: { FormContent, CustomTitleBlock },
  data() {
    return {
      title: "Анкета",
      subtitle: "Заповни анкету, щоб почати полювати",
      isWhiteButton: true,
      data: {
        name: "",
        email: "",
        phone: "",
        age: "",
        work: "",
        subdivision: "",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  background: url("@/assets/images/form/bg.jpeg") no-repeat bottom;
  background-size: cover;
  min-height: 1036px;
  width: 100%;
  color: white;
  padding-top: 1px;
}

.container {
  padding-bottom: 50px !important;
}
</style>
